module.exports = __webpack_public_path__ + "img/logo-meiji.460ec314.svg";